import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Card from '../Card';

const StyledCardList = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: repeat(auto-fit, minmax(22rem, 1fr));
  grid-gap: 1rem;
  justify-items: center;
`;

export function convertFishToCard({
  name,
  image,
  route,
  summary,
}) {
  return {
    title: name,
    image,
    key: route,
    link: `/fish/${route}`,
    description: summary,
  };
}

function CardList({ cards }) {
  const cardsRender = cards.map(card => (
    <Card {...card} key={card.title} />
  ));

  return (
    <StyledCardList>
      {cardsRender}
    </StyledCardList>
  );
}

CardList.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)),
};
CardList.defaultProps = {
  cards: [],
};

export default CardList;



// WEBPACK FOOTER //
// ./src/Components/CardList/index.jsx